import { observer } from 'mobx-react';
import * as style from './TaskScore.module.less';
import { Flex } from '@assets/component/UI/Flex/Flex';

interface ITaskScoreProps {
    score: number | string;
    className?: string;
}

export const TaskScore = observer((p: ITaskScoreProps) => {
    var icon = 'bi bi-check';
    var text = 'Strong';
    var color = '#00A171';

    var score: number = parseInt(p.score.toString());
    //temp hack
    //score = 90;
    //temp hack
    var scoreDisplay = score.toString();
    var bgColor = '#EBFDF8';
    if (score > 85) {
        //defaults
    } else if (p.score == -1) {
        color = '#6C757D';
        bgColor = '#F8F9FA';
        scoreDisplay = '0';
    } else if (score > 55) {
        //Medium
        bgColor = '#FFFAEB';
        color = '#FF9F00';
    } else {
        bgColor = '#FCF3F2';
        color = '#DD2222';
    }

    //scoreDisplay = 'TBD'
    return (
        <Flex
            fillCell={true}
            alignItems="center"
            justify="center"
            style={{
                backgroundColor: bgColor,
                borderRadius: '15px',
                border: '2px solid #f5f5f5ff'
            }}
        >
            <div className={style.numberScore} style={{ color: color }}>
                {scoreDisplay}
                <span className={style.percent}>%</span>
            </div>
        </Flex>
    );

    //<div>{p.score}</div>;
});
